// src/modules/chatbot/components/ChatBubbleUser.tsx

import React from "react";
import { View, StyleSheet, Image } from "react-native";
import { Text } from "react-native-paper";
import { useThemeSettings } from "../../../ThemeProvider";
import { useUserStore } from "../../../store/userStore";
import { CustomIcon } from "../../../components/CustomIcon";

interface ChatBubbleUserProps {
    message: string;
}

// const DEFAULT_AVATAR = "https://randomuser.me/api/portraits/women/44.jpg";

const ChatBubbleUser: React.FC<ChatBubbleUserProps> = ({ message }) => {
    const { theme } = useThemeSettings();
    const { user } = useUserStore();
    return (
        <View style={styles.wrapper}>
            {/* Bubble */}
            <View style={[styles.bubble, { backgroundColor: theme?.colors?.chatBgUser }]}>
                <Text style={[styles.text, { color: theme?.colors?.textPrimary }]}>{message}</Text>
            </View>

            {/* Avatar */}
            {user?.thinkoUser?.picture ?
                <Image
                    source={user?.thinkoUser?.picture}
                    style={styles.avatar}
                /> : <View style={styles.avatar}>
                    <CustomIcon icon="user" size={50} />
                </View>}
        </View>
    );
};

export default ChatBubbleUser;

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        paddingHorizontal: 24,
        marginBottom: 18,
        // width: "100%",
    },

    bubble: {
        // flexGrow:1,
        // flex: 1,
        flexShrink: 1,
        padding: 10,
        borderRadius: 12,
    },

    text: {
        color: "#02030B",
        fontSize: 12,
        lineHeight: 18,
    },
    avatar: {
        width: 50,
        height: 50,
        borderRadius: 25,
        marginLeft: 12,
    },

});